import { getCookiesConsent } from 'cookies'
import type { Session } from 'session/src/types/session'
import { env } from 'utils/envManager'

import type { BeaconEvent } from '../../types/EEC'
import { getGaCookieValue } from '../../utils/getGaCookieValue/getGaCookieValue'

const COLLECTOR_URL = '/ws-wa-sqs-collector/ga-events'

export const sendBeaconServerEvent = (
	session: Session,
	events: BeaconEvent
): boolean | null => {
	// TODO: get for webview
	const appsClientId = ''

	const adsConsent = getCookiesConsent()?.adsConsent ?? false
	const consentAdsPermission = adsConsent ? 'GRANTED' : 'DENIED'

	const body = JSON.stringify({
		consent: {
			ad_user_data: consentAdsPermission,
			ad_personalization: consentAdsPermission,
		},
		client_id: appsClientId || getGaCookieValue(),
		user_id: session.externalId,
		non_personalized_ads: false,
		events: [events],
	})

	return navigator.sendBeacon(
		new URL(COLLECTOR_URL, env.NEXT_PUBLIC_SITE_BASE_URL).href,
		new Blob([body])
	)
}
